export default {
	type: 'object',
	properties: {},
	required: [],
	additionalProperties: false,
}
